export default __webpack_public_path__ + "static/media/techblog3-main.e99b8d56.jpg";